import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export function DashboardPage() {
  const { isSuperAdmin } = useAuth();

  const consoleCards = isSuperAdmin
    ? [
        {
          to: '/users',
          title: 'Users',
          description:
            'Search accounts, review status, and apply activate / deactivate / suspend / reject.',
          action: 'Open users'
        },
        {
          to: '/schools',
          title: 'Schools',
          description:
            'Approve registrations, register schools with school admins, and manage school data.',
          action: 'Open schools'
        },
        {
          to: '/character-pillars',
          title: 'Character pillars',
          description:
            'Create and manage character pillars, missions, learning lectures, and home activities.',
          action: 'Open pillars'
        },
        {
          to: '/badges',
          title: 'Badges',
          description:
            'Create badge definitions, then optionally attach them when creating missions, lectures, or home activities.',
          action: 'Open badges'
        },
        {
          to: '/activity-logs',
          title: 'Activity logs',
          description:
            'Inspect the user-service audit trail for auth, lifecycle, and security actions.',
          action: 'View logs'
        }
      ]
    : [
        {
          to: '/users',
          title: 'School users',
          description:
            'Manage teachers, students, and school admins with role tabs and lifecycle actions.',
          action: 'Open users'
        },
        {
          to: '/classes',
          title: 'Classes',
          description: 'Create classes, assign teachers, enroll students, and manage class status.',
          action: 'Open classes'
        },
        {
          to: '/registration',
          title: 'Registration',
          description: 'Create registration forms, configure workflow steps, share apply links, and manage applications.',
          action: 'Open registration'
        },
        {
          to: '/schools',
          title: 'My school',
          description: 'View and update your school profile and contact details.',
          action: 'Open school'
        },
        {
          to: '/role-change-requests',
          title: 'Role changes',
          description: 'Review identity-level role change requests for your school.',
          action: 'Review requests'
        }
      ];

  return (
    <>
      <section className="admin-intro">
        <h2>{isSuperAdmin ? 'Admin Console' : 'School Console'}</h2>
        <p>
          {isSuperAdmin
            ? 'Super Admin console for platform identities, school onboarding, character pillars, badges, and operational audit trails.'
            : "School Admin console for users, classes, registration, and your school profile."}
        </p>
      </section>

      <section className="admin-grid">
        {consoleCards.map((card) => (
          <Link key={card.to} to={card.to} className="admin-card-link">
            <article>
              <h3>{card.title}</h3>
              <p>{card.description}</p>
              <span className="text-link">{card.action}</span>
            </article>
          </Link>
        ))}
      </section>
    </>
  );
}
